import {Base} from "@/api/Base"

export class InsuranceCompanyAdd extends Base {
    path = "insuranceCompany/add"
}